import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2996922085/src/atua-frontend/src/components/MainScreen.tsx");
